import lottie from 'lottie-web';
import { inView } from 'motion';

// Lottie 

document.addEventListener( 'DOMContentLoaded', function () {

    // Lottie Hover List

    var lottieHoverListContainers = document.getElementsByClassName("lottie-hover-list-container");
    var lottieHoverListAnimations = document.getElementsByClassName("lottie-hover-list");

    let lottieAnimationsListArray = [];

    let lottieAnimationsListCount = 0;

    Array.from(lottieHoverListAnimations).forEach(function(lottieHoverListAnimation) {

        lottieAnimationsListArray[lottieAnimationsListCount] = lottie.loadAnimation({
            container: lottieHoverListAnimation, 
            renderer: 'svg',
            loop: 0,
            autoplay: false,
            path: lottieHoverListAnimation.getAttribute('lottie-src')
        });

        lottieAnimationsListCount++;

    });
    

    Array.from(lottieHoverListContainers).forEach(function(lottieHoverListContainer) {
                
        lottieHoverListContainer.addEventListener("mouseenter", function( event ) {

            let elementID = lottieHoverListContainer.getAttribute("data-lottie-id");

            Array.from(lottieHoverListAnimations).forEach(function(lottieHoverListAnimation) {

                if(lottieHoverListAnimation.getAttribute("data-lottie-id") == elementID) {

                    lottieAnimationsListArray[elementID].setDirection(1);
                    lottieAnimationsListArray[elementID].play();

                }

            });
        
        });

        lottieHoverListContainer.addEventListener("mouseleave", function( event ) {

            let elementID = lottieHoverListContainer.getAttribute("data-lottie-id");

            Array.from(lottieHoverListAnimations).forEach(function(lottieHoverListAnimation) {

                if(lottieHoverListAnimation.getAttribute("data-lottie-id") == elementID) {
                    lottieAnimationsListArray[elementID].setDirection(-1);
                    lottieAnimationsListArray[elementID].play();
                }

            });
        
        });

    });

     // Lottie InView

    let lottieInViewContainers = document.getElementsByClassName('lottie-inview-container')
    var lottieInViewAnimations = document.getElementsByClassName("lottie-inview");

    let lottieInViewAnimationsArray = [];

    let lottieInViewAnimationsCount = 0;

    Array.from(lottieInViewAnimations).forEach((lottieInViewAnimation, lottieInViewAnimationsCount) => {
        
            
            lottieInViewAnimationsArray[lottieInViewAnimationsCount] = lottie.loadAnimation({
                container: lottieInViewAnimation, 
                renderer: 'svg',
                loop: 0,
                name: `${lottieInViewAnimationsCount}`,
                autoplay: false,
                path: lottieInViewAnimation.getAttribute('lottie-src')
            })

            lottieInViewAnimationsCount++
    })
    
    Array.from(lottieInViewContainers).forEach( (lottieInViewContainer) => {
        inView(lottieInViewContainer, () => {

            let containerID = lottieInViewContainer.getAttribute('data-lottie-id')

            Array.from(lottieInViewAnimations).forEach( function(lottieInViewAnimation, index) {
                let animationId = lottieInViewAnimation.getAttribute('data-lottie-id')

                if(animationId == containerID) {
                    lottieInViewAnimationsArray.filter(el => el.name == index).forEach(animation => {
                        // Added a timeout to stagger the animation transitions
                        setTimeout(function() {
                            lottieInViewAnimationsArray[animation.name].setSpeed(.6)
                            lottieInViewAnimationsArray[animation.name].setDirection(1)
                            lottieInViewAnimationsArray[animation.name].play()
                        }, index * 1000);
                    })
                }
            })
        })
    })
});